interface GetConfigParams {
  domain?: string;
  protocol?: string;
  userType?: 'customer' | 'designer' | 'supplier';
}

const getConfig = ({ domain = "", protocol = "", userType = "customer" }: GetConfigParams) => {
  // Default to customer pool
  let userPoolId = "us-east-1_9QPVGsLAP";
  let userPoolWebClientId = "6b83igif6656o7a07jvisv18os";
  let identityPoolId = "us-east-1:972add6b-c3f2-422d-901e-9b0bc50ee943";

  // Override for supplier
  if (userType === "supplier") {
    userPoolId = "us-east-1_yMZBfZQqV";
    userPoolWebClientId = "2l2os9songt95ugi3o70dpkssl";
    identityPoolId = "us-east-1:ec21ff77-39b3-4ef4-bce5-a4d56e1d5581";
  }

  // Override for designer  
  if (userType === "designer") {
    userPoolId = "us-east-1_yMZBfZQqV";
    userPoolWebClientId = "7gtvsv667v91rmcast42k0n1fm";
    identityPoolId = "us-east-1:e237aed2-b53f-415a-8ae2-06429ab611fb";
  }

  const config = {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: userPoolWebClientId,
        identityPoolId
      }
    }
  };
  return config;
};

export default getConfig;